import { DtoType } from '@core/data/dto/dto-types';
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { DeductionSchema } from './deduction.schema';
import { Moment } from 'moment';
import { Employee } from '../employee';
import { DeductionType } from './deduction-type';
import { ChildSupport } from './child-support';
import { Miscellaneous } from './miscellaneous';
@DtoForceConstructor
export class Deduction {

    public id: string;
    public provider: string;
    public providerId: string;
    public source: string;
    public external: boolean;
    public type: DeductionType;
    public employee: Employee;
    public description: string;
    public effectiveStart: Moment;
    public effectiveEnd: Moment;
    public miscellaneous: Miscellaneous;
    public miscellaneousGarnishment: Miscellaneous;
    public childSupport: ChildSupport;
    public managed: boolean;
    public isActive?: boolean;

    @DtoImport(DeductionSchema)
    static import(dto: Dto): any {
        return new Deduction(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeductionSchema,
        },
    ])
    export(type?: DtoType): any {}
}
